import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ITechnicalApplicationEditModel} from '../../api/i-technical-application-edit-model';
import {UpdateTechnicalApplicationModel} from '../../api/update-technical-application-model';

@Component({
  selector: 'app-technical-application-form',
  templateUrl: './technical-application-form.component.html',
  styleUrls: ['./technical-application-form.component.scss']
})
export class TechnicalApplicationFormComponent implements OnInit {

  @Input() item: ITechnicalApplicationEditModel = new UpdateTechnicalApplicationModel();
  @Output()
  changeImage = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  get wet(): boolean {
    return  this.item.wet === 'Y';
  }

  set wet(value: boolean) {
    this.item.wet = value ? 'Y' : 'N';
  }

  get active(): boolean {
    return  this.item.state === 'A';
  }

  set active(value: boolean) {
    this.item.state = value ? 'A' : 'R';
  }
}
